import utils from '@/app/utils/utils';
import * as _ from 'lodash-es';
import { DateTime } from 'luxon';

export const capitalizeFirstLetter = (value: string) =>
  value ? value.toString().charAt(0).toUpperCase() + value.toString().slice(1) : '';

export const dashify = (value: string) => (value ? value : '-');

export const formatRooms = (str: string) => (str ? str.replace(/,/g, ', ').replace(/\+/g, ' + ') : '');

export const yesNo = (value: any) => (!!value ? 'Kyllä' : 'Ei');

export const number = utils.formatNumber;

type EuroOptions = {
  isPrecise?: boolean;
  dashify?: boolean;
  perPerson?: boolean;
  perMonth?: boolean;
};
export const euro = (value: any, options: EuroOptions = {}) => {
  const formatted = options.isPrecise ? utils.formatNumber(value, 2) : utils.formatNumber(value, 0);

  // Dashify after rounding to catch 0.01 values
  if (options.dashify && _.toNumber(formatted) <= 0) {
    return '-';
  }

  let unit = '€';
  if (options.perPerson) {
    unit += '/hlö';
  }
  if (options.perMonth) {
    unit += '/kk';
  }

  return `${formatted} ${unit}`;
};

export const formatISODate = (value: any) => (value ? DateTime.fromISO(String(value)).toFormat('d.M.yyyy') : '');

type ShortenOptions = {
  words?: number;
};

export const shorten = (value: string, options: ShortenOptions = {}) => {
  const words = options.words || 20;
  let shortenedText = value;
  const textParts = value.split(' ');

  if (textParts.length > words) {
    shortenedText = `${textParts.slice(0, words).join(' ')}...`;
  }

  return shortenedText;
};

export const iconifyLink = (value: string) => {
  return value.replace(new RegExp(' &gt;', 'g'), '');
};

export const iconifyGreaterThanSign = (value: string) => {
  return value.replace(' >', '');
};
